import React from 'react';
import TextInput from '../FormElements/TextInput';
import EmailInput from '../FormElements/EmailInput';
import PasswordInput from '../FormElements/PasswordInput';
import PhoneNumberInput from '../FormElements/PhoneNumberInput';
import Selectbox from '../FormElements/Selectbox';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import DateInput from '../FormElements/DateInput';
import Switch from '../FormElements/Switch';
import AddressInput from '../FormElements/AddressInput';
import bootbox from 'bootbox';
import PermissionsHelper from '../../libraries/permissionsHelper';

export default class Signup extends React.Component {
	constructor(props) {
		super(props);

		// prep form fields
		var form_fields = {};
		if (this.props.fields && this.props.fields.length > 0) {
			for (var i = 0, ilen = this.props.fields.length; i < ilen; i++) {
				form_fields[this.props.fields[i].name] = this.props.fields[i].value;
			}
		}

		this.state = {
			agree_terms: false,
			error: null,
			form_fields: form_fields,
			loading: false,
			password: '',
			principal: this.props.principal || ''
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeField = this.onChangeField.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onShowTerms = this.onShowTerms.bind(this);
		this.onToggleAgreeTerms = this.onToggleAgreeTerms.bind(this);
	}

	render() {
		console.log('Signup', this.props, this.state);

		if (this.props.status === 'fail') {
			return (
				<div className="Signup FormElements">
					<form>
						<div
							className="alert alert-danger"
							dangerouslySetInnerHTML={{
								__html: I18n.t(this.props.error, {
									login_path: this.props.sign_in_path
								})
							}}
						/>
					</form>
				</div>
			);
		} else {
			return (
				<div className="Signup FormElements">
					{this.state.error && (
						<div
							className="alert alert-danger"
							dangerouslySetInnerHTML={{
								__html: I18n.t(this.state.error, {
									login_path: this.props.sign_in_path
								})
							}}
						/>
					)}
					{this.state.global_error && (
						<div
							className="alert alert-danger"
							dangerouslySetInnerHTML={{
								__html: I18n.t(this.state.global_error, {
									login_path: this.props.sign_in_path
								})
							}}
						/>
					)}
					<form onSubmit={this.onSubmit}>
						<h1>
							{this.props.invitation_code ? (
								'Finish setting up your account'
							) : (
								'Sign up'
							)}
						</h1>
						{this.renderFields()}
						<FormSection style={{ marginTop: '25px', marginBottom: '25px' }}>
							<div className="HelperText" style={{ textAlign: 'center' }}>
								<input
									type="checkbox"
									name="agree_terms"
									checked={this.state.agree_terms}
									onChange={this.onToggleAgreeTerms}
								/>{' '}
								I agree to the{' '}
								<a href="#" onClick={this.onShowTerms}>
									Terms of Use
								</a>
							</div>
						</FormSection>
						<FormSection>
							<FormSubmit
								text="Create Account"
								disabled={this.state.agree_terms === false}
							/>
						</FormSection>
					</form>
					{this.state.loading ? (
						<div className="loadingOverlay">
							<div className="spinner" />
						</div>
					) : null}
				</div>
			);
		}
	}

	renderFields() {
		var self = this;
		if (this.props.fields && this.props.fields.length > 0) {
			var fields = this.props.fields.map(function(field) {
				const { static: readOnly = false } = field;
				if (field.hidden) {
					// hidden input
					return (
						<input
							key={field.name}
							type="hidden"
							name={field.name}
							readOnly={readOnly}
							value={self.state.form_fields[field.name] || ''}
						/>
					);
				} else if (field.type == 'TEXT') {
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<TextInput
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								onChange={self.onChangeField}
								readOnly={readOnly}
								helperText={field.helperText}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'EMAIL_ADDRESS') {
					// email address input
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<EmailInput
								readOnly={readOnly}
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								onChange={self.onChangeField}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'PASSWORD') {
					// password
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<PasswordInput
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								onChange={self.onChangeField}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'PHONE_NUMBER') {
					// phone number
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<PhoneNumberInput
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								onChange={self.onChangeField}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'SELECT') {
					// dropdown / selectbox
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<Selectbox
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								placeholder={field.placeholder}
								helperText={field.helperText}
								options={field.options}
								onChange={self.onChangeField}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'CALENDAR_DATE') {
					// month / year
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<DateInput
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								placeholder={field.placeholder}
								helperText={field.helperText}
								options={field.options}
								onChange={self.onChangeField}
								months={Array.from({ length: 12 }, (e, i) => {
									return {
										value: i,
										content: new Date(
											null,
											i + 1,
											null
										).toLocaleDateString('en', {
											month: 'long'
										})
									};
								})}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'CALENDAR_MONTH') {
					// month / year
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<DateInput
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								placeholder={field.placeholder}
								helperText={field.helperText}
								options={field.options}
								onChange={self.onChangeField}
								hideDay={true}
								months={Array.from({ length: 12 }, (e, i) => {
									return {
										value: i,
										content: new Date(
											null,
											i + 1,
											null
										).toLocaleDateString('en', {
											month: 'long'
										})
									};
								})}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				} else if (field.type === 'BOOLEAN') {
					// month / year
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<Switch
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								isOn={self.state.form_fields[field.name] || ''}
								handleToggle={() =>
									self.onChangeField({
										target: {
											name: field.name,
											value: !self.state.form_fields[field.name]
										}
									})}
								onText={I18n.t('yes')}
								offText={I18n.t('no')}
							/>
							{self.renderFieldError(field.name) ? (
								<div style={{ clear: 'both', marginTop: '17px' }}>
									{self.renderFieldError(field.name)}
								</div>
							) : null}
						</div>
					);
				} else if (field.type === 'POSTAL_ADDRESS') {
					// address
					return (
						<div
							key={field.name}
							className={self.hasError(field.name) ? 'has-error' : ''}
						>
							<label>{field.displayName}</label>
							<AddressInput
								name={field.name}
								value={self.state.form_fields[field.name] || ''}
								onChange={self.onChangeField}
							/>
							{self.renderFieldError(field.name)}
						</div>
					);
				}
			});

			return <div className="fields">{fields}</div>;
		}
	}

	renderFieldError(field_name) {
		if (this.state.field_errors && this.state.field_errors[field_name]) {
			return (
				<div
					className="field-error"
					dangerouslySetInnerHTML={{
						__html:
							this.state.field_errors[field_name].indexOf(' ') >= 0
								? this.state.field_errors[field_name]
								: I18n.t(this.state.field_errors[field_name])
					}}
				/>
			);
		}
	}

	onChange(e) {
		var { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onChangeField(e) {
		var { state } = this;
		state.form_fields[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		if (this.state.agree_terms) {
			var self = this;

			e.preventDefault();
			e.stopPropagation();

			this.setState({ loading: true });

			$.ajax({
				type: 'POST',
				url: this.props.registration_path,
				data: this.prepParams()
			}).done(function(data) {
        console.log('onSubmit', data);
				if (data.status == 'success') {
					const { permissions } = data.user.decoded_access_token;
					const permissionHelper = new PermissionsHelper(permissions);

					if (permissionHelper.isOnlyProctor()) {
						window.location.href = `/admin/${data.account_id}/users`;
					} else {
						window.location.href = data.redirect_to;
					}
				} else {
					self.setState({
						loading: false,
						error: data.error,
						global_error:
							data.global_error && data.global_error.some((el) => el !== null)
								? data.global_error
								: null,
						field_errors: data.field_errors
					});
				}
			});
		}
	}

	onShowTerms() {
		var terms_modal = bootbox.alert({
			className: 'modal-fullscreen',
			size: 'large',
			message: this.props.terms_text,
			className: 'terms_modal',
			onShow: function() {
				$('.terms_modal').animate({ scrollTop: 0 }, 500, 'swing');
			},
			callback: function() {
				// close terms
			}
		});
	}

	onToggleAgreeTerms() {
		this.setState({ agree_terms: !this.state.agree_terms });
	}

	/**
   * Helper functions
   */

	hasError(field_name) {
		return (
			this.state.field_errors &&
			typeof this.state.field_errors[field_name] !== 'undefined'
		);
	}

	prepParams() {
		var { form_fields: data } = this.state;
		var params = { ...data };

		for (var key in params) {
			var field = this.getField(key);
			if (field && field.type === 'PASSWORD') {
				params[key] = btoa(params[key]);
			} else if (field && field.type === 'CALENDAR_MONTH') {
				var date_obj = params[key];
				if (date_obj && date_obj.month) {
					var date = new Date();
					date.setMonth(date_obj.month);
					date.setFullYear(date_obj.year);
					params[key] = date.toISOString();
				}
			} else if (field && field.type === 'CALENDAR_DATE') {
				var date_obj = params[key];
				if (date_obj && date_obj.day) {
					var date = new Date();
					date.setDate(date_obj.day);
					date.setMonth(date_obj.month);
					date.setFullYear(date_obj.year);
					params[key] = date.toISOString();
				}
			} else if (field && field.type === 'BOOLEAN') {
				if (params[key] === null) {
					params[key] = false;
				}
			}
		}

		params['context'] = this.props.context;
		console.log('prepParams after', params);
		return params;
	}

	getField(field_name) {
		for (var i = 0, ilen = this.props.fields.length; i < ilen; i++) {
			if (this.props.fields[i].name === field_name) {
				return this.props.fields[i];
			}
		}
	}
}
